import { render, staticRenderFns } from "./LoadResume.vue?vue&type=template&id=6a527dd7&scoped=true"
import script from "./LoadResume.vue?vue&type=script&lang=js"
export * from "./LoadResume.vue?vue&type=script&lang=js"
import style0 from "./LoadResume.vue?vue&type=style&index=0&id=6a527dd7&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a527dd7",
  null
  
)

export default component.exports